var exports = {
  "z": "x127c5a35--1b26da--controls-tablet-cell",
};

module.exports = exports;
